import { Settings } from "./settings"


export class ApiUrls {
    public static ApplicationAPIBaseUrl: string = Settings.ApplicationAPIBaseUrl




    public static IsExistsMainContact: string = `${ApiUrls.ApplicationAPIBaseUrl}/Client/ClientManager/IsExistsMainContact`

    public static CreateMainContact: string = `${ApiUrls.ApplicationAPIBaseUrl}/Client/ClientManager/CreateMainContact`

    public static GetCountPersonalAccount: string = `${ApiUrls.ApplicationAPIBaseUrl}/PersonalAccount/PersonalAccountManager/GetCountPersonalAccount`

    public static GetAttachPersonalAccount: string = `${ApiUrls.ApplicationAPIBaseUrl}/PersonalAccount/PersonalAccountManager/GetAttachPersonalAccount`

    public static AttachPersonalAccount: string = `${ApiUrls.ApplicationAPIBaseUrl}/PersonalAccount/PersonalAccountManager/AttachPersonalAccount`

    public static UnAttachPersonalAccount: string = `${ApiUrls.ApplicationAPIBaseUrl}/PersonalAccount/PersonalAccountManager/UnAttachPersonalAccount`

    public static GetPersonalAccountShortInformation: string = `${ApiUrls.ApplicationAPIBaseUrl}/PersonalAccount/PersonalAccount/GetPersonalAccountShortInformation`

    public static GetPersonalAccountInformation: string = `${ApiUrls.ApplicationAPIBaseUrl}/PersonalAccount/PersonalAccount/GetPersonalAccountInformation`

    public static GetServiceObjectTypeNumber: string = `${ApiUrls.ApplicationAPIBaseUrl}/Settings/Setting/GetServiceObjectTypeNumber`

    public static GetServiceObjectTypeAttachAccount: string = `${ApiUrls.ApplicationAPIBaseUrl}/Settings/Setting/GetServiceObjectTypeAttachAccount`

    public static GetServiceObjects: string = `${ApiUrls.ApplicationAPIBaseUrl}/Spektr/ServiceObjects/AddressLayout/GetServiceObjects`

    public static GetServiceObject: string = `${ApiUrls.ApplicationAPIBaseUrl}/Spektr/ServiceObjects/AddressLayout/GetServiceObject`



    public static GetParameterTempleteInformation: string = `${ApiUrls.ApplicationAPIBaseUrl}/Spektr/Appeal/AppealParameter/GetParameterTempleteInformation`

    /*Equipment */

    public static GetAvailableEquipments: string = `${ApiUrls.ApplicationAPIBaseUrl}/Equipments/AvailableEquipment/GetAvailableEquipments`

    public static GetEquipmentImage: string = `${ApiUrls.ApplicationAPIBaseUrl}/Util/FIle/EquipmentImage`

    /*Equipment */

    public static GetCommonReferences: string = `${ApiUrls.ApplicationAPIBaseUrl}/Spektr/Reference/CommonReference/GetCommonReferences`

    public static GetDeadlineDateExecution: string = `${ApiUrls.ApplicationAPIBaseUrl}/Spektr/Appeal/ParameterUtil/GetDeadlineDateExecution`



    public static GetAvailableMobileServices: string = `${ApiUrls.ApplicationAPIBaseUrl}/Spektr/Services/MobileService/GetAvailableMobileServices`

    public static GetProcessingServices: string = `${ApiUrls.ApplicationAPIBaseUrl}/Client/ClientService/GetProcessingServices`

    public static ActivationMobileService: string = `${ApiUrls.ApplicationAPIBaseUrl}/Client/ClientService/ActivationMobileService`

    public static ProcessingServiceChangeHub: string = `${ApiUrls.ApplicationAPIBaseUrl}/hubs/ProcessingServiceChange`

    public static CancelProcessingServices: string = `${ApiUrls.ApplicationAPIBaseUrl}/Client/ClientService/CancelProcessingServices`

    public static CancelSubscriptionRenewal: string = `${ApiUrls.ApplicationAPIBaseUrl}/Client/ClientService/CancelSubscriptionMobileService`


    /*Appeals*/
    public static GetAppealTopics: string = `${ApiUrls.ApplicationAPIBaseUrl}/Spektr/Appeal/AppealReference/GetAppealTopics`

    public static GetAppealTags: string = `${ApiUrls.ApplicationAPIBaseUrl}/Spektr/Appeal/AppealReference/GetAppealTags`

    public static GetAppealAdditionalTags: string = `${ApiUrls.ApplicationAPIBaseUrl}/Spektr/Appeal/AppealReference/GetAppealAdditionalTags`

    public static GetAppealTagParameterInformation: string = `${ApiUrls.ApplicationAPIBaseUrl}/Spektr/Appeal/AppealParameter/GetAppealTagParameterInformation`

    public static UploadAppealClientFile: string = `${ApiUrls.ApplicationAPIBaseUrl}/Util/ClientFile/AppealClientFile/UploadAppealClientFile`
    public static GetAppealClientFile: string = `${ApiUrls.ApplicationAPIBaseUrl}/Util/ClientFile/AppealClientFile/GetAppealClientFile`

    public static RemoveAppealClientFile: string = `${ApiUrls.ApplicationAPIBaseUrl}/Util/ClientFile/AppealClientFile/RemoveAppealClientFile`

    public static GetAppeals: string = `${ApiUrls.ApplicationAPIBaseUrl}/Spektr/Appeal/TaskTag/GetAppeals`

    public static GetAppealInformation: string = `${ApiUrls.ApplicationAPIBaseUrl}/Spektr/Appeal/TaskTag/GetAppealInformation`

    public static CreateTaskDialog: string = `${ApiUrls.ApplicationAPIBaseUrl}/Spektr/Appeal/TaskTag/CreateTaskDialog`

    public static SetQuailty: string = `${ApiUrls.ApplicationAPIBaseUrl}/Spektr/Appeal/TaskTag/SetQualityTaskTag`

    public static GetTubeTaskTagTemplete: string = `${ApiUrls.ApplicationAPIBaseUrl}/Settings/Setting/GetTubeTaskTagTemplete`
    /*Appeals*/

    /*UserNotofication */
    public static GetUserNotifications: string = `${ApiUrls.ApplicationAPIBaseUrl}/Users/UserNotification/GetUserNotifications`

    public static ReadUserNotification: string = `${ApiUrls.ApplicationAPIBaseUrl}/Users/UserNotification/ReadUserNotification`

    public static UserNotificationHub: string = `${ApiUrls.ApplicationAPIBaseUrl}/hubs/UserNotification`

    /*UserNotofication */
}